<template>
  <div class="axj-main">
    <axj-tool
      @next="handleNext"
      @pre="handlePre"
    />

    <axj-main-top/>
    <axj-main-menu />
    <axj-main-body/>
  </div>
</template>

<script>

import AxjMainTop from "./component/axj-main-top/index";
import AxjMainBody from "./component/axj-main-body/index";
import AxjMainMenu from "./component/axj-main-menu/index";
import AxjTool from "./component/axj-tool/index";
export default {
  name: "index",
  components: {AxjTool, AxjMainMenu, AxjMainBody, AxjMainTop},
  methods:{
    handleNext(){
      window.parent.handleNext()
    },
    handlePre(){
      window.parent.handlePre()
    }
  },
  mounted() {
    //axjMainModels.fitWindow()
  },

  data(){
    return{
      thisPageConfig:{
        //爱学界顶部默认高度
        defaultAxjMainTopHeight:132,
        //默认爱学界主体宽度
        defaultAxjMainBodyWith:1309,
        //默认爱学界图标图片高度
        defaultAxjMainTopIconImageHeight:55,
        //默认爱学界图标图片宽度
        defaultAxjMainTopIconImageWidth:225.34,
        defaultAxjMainTopIconMarginTop:29,
        defaultAxjMainTopIconLabelFontSize:24,
        defaultAxjMainTopIconLabelLineHeight:189.3,
        defaultAxjMainTopWidth:1309
      }
    }
  },
}
</script>

<style slot-scope lang="scss">
.axj-main{
  height: 100vh;
  padding: 0;
  overflow-y: scroll;
  background-color: #F2F5F8;
}
</style>



// WEBPACK FOOTER //
// src/views/axj-main/index.vue